import styled from 'styled-components';
import { Toggle as Tgl } from '@fluentui/react';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
`;
export const HeaderContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 10px;

    @media(max-width: 640px)
    {
        flex-direction: column;
        align-items: flex-start;
        gap: 15px;
    }
`;
export const TitleContainer = styled.div`
    flex: 1;
    @media(max-width: 640px)
    {
        width: 100%;
    }
`;
export const ButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    @media(max-width: 640px)
    {
        width: 100%;
        justify-content: flex-start;
    }
`;
export const Title = styled.h1`
    cursor: default;
    margin: 0;

    @media(max-width: 640px)
    {
        font-size: 24px;
        margin-bottom: 0;
    }
`;
export const ButtonRegister = styled.button`
    background-color: #CC214F;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 12px;
    cursor: pointer;
    white-space: nowrap;

    @media(max-width: 640px)
    {
        padding: 12px 24px;
        font-size: 14px;
    }
`;
export const FMContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex: 0 0 auto;
    margin-bottom: 10px;
    overflow-x: hidden !important;
`;
export const FMTitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex: 0 1 10px;
    margin-bottom: 10px;
`;
export const FMTitle = styled.h4`
    font-size: 12px;
    font-weight: 500;
    margin: 0px;
    color: #95a0a1;
    cursor: default;
`;
export const FMCardsContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    flex: 1;
    overflow-x: hidden;
    @media(min-width: 1440px)
    {
        justify-content: space-between;
    }
`;
export const FilterBadgeContainer = styled.div`
    display: flex;
    margin: 5px 10px 10px 10px;
    flex-wrap: wrap;
    gap: 10px;
`;
export const FiltersWrapper = styled.div`
    display: flex;
    flex: 0 1 auto;
    flex-wrap: wrap;
    margin-bottom: 10px;
    justify-content: flex-start;
    gap: 15px;
    width: 100%;
    align-items: flex-start;

    @media(max-width: 1200px)
    {
        justify-content: flex-start;
        gap: 10px;
    }

    @media(max-width: 768px)
    {
        justify-content: flex-start;
        gap: 8px;
    }

    @media(max-width: 640px)
    {
        flex-direction: column;
        gap: 15px;
    }
`;

export const FilterContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    flex: 1 1 auto;
    min-width: 140px;
    max-width: 200px;
    padding: 0 5px;
    margin-bottom: 10px;

    &.short-select button
    {
        padding: 7px 20px 5px;

        span:first-of-type
        {
            position: relative;
            top: -2px;
        }
    }

    > div span
    {
        border-radius: 100px;
    }

    i
    {
        color: white;
    }

    @media(max-width: 1200px)
    {
        flex: 1 1 auto;
        min-width: 120px;
        max-width: 180px;
        padding: 0 3px;
    }

    @media(max-width: 768px)
    {
        flex: 1 1 auto;
        min-width: 100px;
        max-width: 150px;
        padding: 0 2px;
    }

    @media(max-width: 640px)
    {
        flex: none;
        width: 100%;
        min-width: auto;
        max-width: none;
        padding: 0 0 10px 0;
    }
`;

export const ToggleContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: ${(props) => props.theme.palette.white};
    padding: 8px 15px;
    border-radius: 100px;
    border: 1px solid rgb(188, 200, 201);
    cursor: default;
    font-weight: 500;
    font-size: 14px;
    color: ${(props) => props.theme.palette.lightBlack} !important;
    width: 100%;
    min-width: 130px;
    white-space: nowrap;
    box-sizing: border-box;

    @media(max-width: 1200px)
    {
        min-width: 110px;
        padding: 6px 12px;
        font-size: 13px;
    }

    @media(max-width: 768px)
    {
        min-width: 90px;
        font-size: 12px;
        padding: 4px 10px;
    }

    @media(max-width: 640px)
    {
        min-width: auto;
        font-size: 14px;
        padding: 8px 15px;
    }
`;

export const ToggleTitle = styled.span`
    margin-right: 10px;
    margin-left: 0;
    height: 100%;
    cursor: default;
    flex: 1;
    text-align: left;

    @media(max-width: 768px)
    {
        margin-right: 8px;
        margin-left: 0;
    }

    @media(max-width: 640px)
    {
        margin-right: 10px;
        margin-left: 0;
    }
`;

export const Toggle = styled(Tgl)`
    margin: 0;
`;

export const TableWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    background: ${(props) => props.theme.palette.background};
    border-radius: 16px;
`;

export const TableWidthManager = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 30px;
    box-shadow: ${(props) => props.theme.palette.white === "#FFFFFF" 
        ? "0px 0px 16px rgba(8, 84, 117, 0.15)" 
        : "0px 0px 16px rgba(255, 255, 255, 0.12)"};
    border-radius: 16px;
    min-height: 500px;
`;

export const TableFilterContainer = styled.div`
    display: flex;
    flex: 0 1 50px;
    margin-bottom: 2em;
    width: 100%;
    align-items: center;
    gap: 15px;

    @media(max-width: 640px)
    {
        flex-direction: column;
        align-items: stretch;
        gap: 10px;
    }

    > *
    {
        vertical-align: top;
        flex-direction: column;
        display: block;
    }
`;

export const TRCountContainer = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex: 0 0 auto;
    max-width: min(25%, 300px);
    min-width: 150px;
    padding-left: 16px;

    @media(max-width: 640px)
    {
        flex: none;
        max-width: none;
        min-width: auto;
        width: 100%;
        justify-content: center;
        order: 1;
        padding-left: 0;
    }
`;
export const TRTitle = styled.span`
    font-size: 19px;
    font-weight: 500;
    cursor: default;
    color: ${(props) => props.theme.palette.neutralPrimary};
`;
export const TRCount = styled.span`
    color: ${(props) => props.theme.palette.neutralText};
    margin-left: 5px;
`;

export const InputSearchContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: center;
    margin: 0 10px;

    &.jcl
    {
        justify-content: left;
    }

    @media(max-width: 640px)
    {
        margin: 0;
        order: 2;
    }

    > div,
    input
    {
        border-radius: 100px;
        border: 1px solid ${(props) => props.theme.palette.borderSecondary};
        padding-left: 10px;
        background: ${(props) => props.theme.palette.inputBackground};
        color: ${(props) => props.theme.palette.neutralPrimary};
        padding-top: 1px;
        padding-right: 2px;
        margin-bottom: 0.5px;

        :hover
        {
            border: 1px solid ${(props) => props.theme.palette.borderSecondary};
        }
        ::after
        {
            border: none;
        }
    }
`;

export const EditColumnContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex: 0 0 10%;
    max-width: 10%;
    min-width: 80px;
    padding-right: 15px;

    @media(max-width: 640px)
    {
        flex: none;
        max-width: none;
        min-width: auto;
        width: 100%;
        justify-content: center;
        padding-right: 0;
        order: 3;
    }
`;

export const TableContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    overflow-x: auto;
    border-bottom: 1px solid ${(props) => props.theme.palette.borderSecondary};
    background: transparent;
    color: ${(props) => props.theme.palette.neutralPrimary};
    table
    {
        border-radius: 16px;
    }
    thead
    {
        background: ${(props) => props.theme.palette.grey};
        color: ${(props) => props.theme.palette.neutralPrimary};
    }
    > div
    {
        margin: 0;
    }

    .is-selected
    {
        a, div
        {
            color: white !important;
        }
    }
`;

export const PaginationContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-top: 30px;
    gap: 20px;

    span
    {
        color: ${(props) => props.theme.palette.neutralText};
        border-radius: 16px;
        line-height: 28px;
    }

    > *
    {
        display: flex;
        align-items: center;
    }
`;

export const ProductsPerPage = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 20px;
    height: 100%;
    color: ${(props) => props.theme.palette.neutralText};

    select
    {
        min-width: 70px;
        border: none;
        border-bottom: 1px solid ${(props) => props.theme.palette.neutralPrimary};
        padding: 5px 0;
        background: transparent;
        color: ${(props) => props.theme.palette.neutralPrimary};
    }
`;

export const PageCount = styled.div`
    display: flex;
    color: ${(props) => props.theme.palette.neutralText};
`;

export const PageButtons = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;

    button
    {
        cursor: pointer;
        border: none;
        background: transparent;
        color: #CC214F;
        padding: 6px 8px;
        border-radius: 6px;
        transition: all 0.2s ease;
        font-size: 16px;
        min-width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;

        &:hover:not(.disabled)
        {
            background: rgba(204, 33, 79, 0.1);
            color: #CC214F;
            transform: scale(1.05);
        }

        &:active:not(.disabled)
        {
            background: rgba(204, 33, 79, 0.2);
            transform: scale(0.95);
        }

        &.disabled
        {
            cursor: default;
            color: #D1D5DB;
            background: transparent;
            opacity: 0.5;
        }

        i
        {
            font-size: 16px;
        }
    }
`;

export const FilterLabelContainer = styled.div`
    text-align: left;
`;
export const FilterLabel = styled.label`
    color: grey;
    font-size: 12px;
    margin-top: 5px;
    width: 100%;
    padding-left: 10px;
    display: block;
`;